import { Box } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { createContext, useState } from 'react';
import './App.css';
import { Footer } from './components/Footer';
import ResponsiveAppBar from './components/ResponsiveAppBar';

export const ScrollContext = createContext();

const theme = createTheme({
  palette: {
    primary: {
      main: '#DF6F5B',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#121D21',
      contrastText: '#F7F7F7',
    },
    info: {
      main: '#237371',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#000000'
    }
  },
});


function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [alwaysShowBackground, setAlwaysShowBackground] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <ScrollContext.Provider value={{ isScrolled, setIsScrolled, alwaysShowBackground, setAlwaysShowBackground }}>
        <Box sx={{ width: '100%', minHeight: '100%', position: 'relative', display: 'flex', flexDirection: 'column' }}>
          <Box id='header' sx={{ width: '100%' }}>
            <ResponsiveAppBar></ResponsiveAppBar>
          </Box>
          <Box id="content" sx={{ flex: 1, width: '100%' }}>
            <Outlet />
          </Box>
          <Box id='footer' sx={{ width: '100%' }}>
            <Footer></Footer>
          </Box>
        </Box >
      </ScrollContext.Provider>
    </ThemeProvider>
  );
}

export default App;
